import { UIShipHoverActionController } from '../ui_game_hover_actions/UIShipHoverActionController.ts';
import { UIMoveShipHoverActionController } from '../ui_game_hover_actions/UIMoveShipHoverActionController.ts';
export class UIGameMapShipController {
    initializeHoverActions(shipState, mechanicPirateState) {
        new UIShipHoverActionController(this.uiGameManager, shipState, mechanicPirateState);
        new UIMoveShipHoverActionController(this.uiGameManager, shipState, mechanicPirateState);
    }
    constructor(uiGameManager, shipState, mechanicPirateState){
        this.uiGameManager = uiGameManager;
        if (this.uiGameManager.gameController.isReplay) return;
        this.initializeHoverActions(shipState, mechanicPirateState);
    }
}
